export default "__VITE_ASSET__xM2I8pu4__"